import { ClientGateway } from "@kex/api";
import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";

import { exchangePairsApi } from "@shared/api";

import { constants } from "./constants";

type Props = {
  params: ClientGateway.ExchangePairsApiGetApiV1ExchangePairsRequest;
  refetchOnWindowFocus?: boolean;
};

export const exchangePairsQueryOptions = ({
  params,
  refetchOnWindowFocus,
}: Props) =>
  queryOptions({
    gcTime: 0,
    queryFn: () => exchangePairsApi.getApiV1ExchangePairs(params),
    queryKey: constants.get(params),
    refetchOnWindowFocus,
    staleTime: 0,
  });

export const useExchangePairs = (props: Props) => {
  const { data, error, isPending } = useSuspenseQuery(
    exchangePairsQueryOptions(props),
  );

  return { data: data.data, error, isPending };
};
